import { Link } from "react-router-dom";
import { articleList } from "@/mocks/articles";

/* Show all 10 articles in a grid, the first one being the flagship Guide */
export default function ArticleCards() {
  if (articleList.length < 2) return null;

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            In-Depth Sugargoo Guides &amp; Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Explore our collection of detailed SEO guides covering every aspect of Sugargoo shopping — from reviews and shipping to product finds and safety analysis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:gap-2 transition-all">
                  Read Article
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}